import { type ObjectValuesUnionType } from '../../../utils/typing';
import type { GiftRaceId } from '../types/global';

export const GiftRaceStorageKeyTypes = Object.freeze({
  HOME_ANIMATION_BEEN_VIEWED: 'HOME_ANIMATION_BEEN_VIEWED',
});
export type GiftRaceStorageKeyType = ObjectValuesUnionType<typeof GiftRaceStorageKeyTypes>;

const GiftRaceStorageValuesByKeyTypes = Object.freeze({
  [GiftRaceStorageKeyTypes.HOME_ANIMATION_BEEN_VIEWED]: 'homeAnimationViewed',
});

export const getGiftRaceStorageKey = (grId: GiftRaceId, keyType: GiftRaceStorageKeyType) =>
  `application:betting:gr_${grId?.toLowerCase() ?? ''}:${GiftRaceStorageValuesByKeyTypes[keyType] ?? ''}`;
